import * as React from 'react';
import { useApiListener } from '@process-advisor/process-miner/shared/hooks/useApiListener';
import {
    StyledWrapper,
    StyledContent,
    StyledModal,
    StyledHeader,
    StyledIcon,
    StyledFooter,
    StyledTitle,
} from '@process-advisor/process-miner/components/modal/modal.styles'
import { Button } from '@process-advisor/process-miner/components/shared/button';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { Event } from '@process-advisor/process-miner/api/events';
import styled from 'styled-components';
import * as Highcharts from 'highcharts/highstock';
import { HighChart } from '@process-advisor/process-miner/modals/history/highChart';
import { Dropdown } from '@process-advisor/process-miner/components/shared/dropdown';
import { Section } from '@process-advisor/process-miner/modals/section';
import { SingleBlock } from '@process-advisor/process-miner/components/layout/singleBlock';
import { Checkbox } from '@process-advisor/process-miner/components/shared/checkbox';

const Analytic = styled.div`
    width: 900px;
    height: 650px;
    border: hidden;
    canvas {
        outline: none;
    };
`;

const Wrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin-bottom: 5px;
`;


type Props = {
    props: {
        variant: number,
        activity: number,
        from: number,
        to: number,
        discovery_rule_id: number,
        discovery_rule_type: string,
        object_type: string,
        object_name: string,
        series_name: string,
        source: string,
    },
}

export type Data = []

export const ProcessAnalyticsModal: React.FC = () => {
    const [data, setData] = React.useState<Data[]>([]);
    const [props, setProps] = React.useState<{  variant: number, activity: number, from: number, to: number, discovery_rule_id: number, discovery_rule_type:string, object_type: string, object_name: string, series_name: string, source: string}>({ variant: 0, activity: 0, from: 0, to: 0, discovery_rule_id: 0, discovery_rule_type: '', object_type: '', object_name: '', series_name: '', source: ''});
    const [open, setOpen] = React.useState(false);
    const [title, setTitle] = React.useState('');
    const [metric, setMetric] = React.useState(1);
    const [showCloseIcon, setShowCloseIcon] = React.useState(true);
    const [showButtons, setShowButtons] = React.useState(true);
    const [showDataLabels, setShowDataLabels] = React.useState(false);

    let optionsMetrics = [
            { value: 1, label: 'Volume' },
            { value: 2, label: 'Avg Duration (mins)' },
            { value: 3, label: 'Avg Duration (hrs)' },
            { value: 4, label: 'Avg Duration (days)' },
            { value: 7, label: 'Worklogs'},
            { value: 8, label: 'Avg TimeSpent (mins)'},
            { value: 9, label: 'Total Time Spent (mins)'},
        ];

    const onMetricChange = (metricSelected: number) => {
        setMetric(metricSelected);
        apiProvider.changeAnalyticsTaskAttributeMetric({ metric : metricSelected });
        setData(apiProvider.processAnalyticsHistory({type: props.object_type, variant: props.variant, activity: props.activity, from: props.from, to: props.to, discovery_rule_id: props.discovery_rule_id, discovery_rule_type: props.discovery_rule_type, source: props.source}));
    };

    function onClose() {
        setOpen(false)
    }
    useApiListener(
        Event.openProcessAnalyticsModal,
        ({ props }: Props) => {
            setOpen(true);
            setProps(props);
            setTitle(props.object_type + ' ' + apiProvider.getEntityUpper() + ' History'  )
            const timer = setTimeout(() => {
                setData(apiProvider.processAnalyticsHistory({type: props.object_type, variant: props.variant, activity: props.activity, from: props.from, to: props.to, discovery_rule_id: props.discovery_rule_id, discovery_rule_type: props.discovery_rule_type, source: props.source}));
            }, 100);
            return () => clearTimeout(timer);
        }
    );

    const options: Highcharts.Options = {
        chart: {
            zoomType: 'x',
            style: {
                fontFamily: 'system-ui'
,
            },
            borderWidth: 2,
            borderColor: '#E0E0E0',            
        },
        title: {
            text: null
        },
        subtitle: {
            text: document.ontouchstart === undefined ?
                'Click and drag in the plot area to zoom in' : 'Pinch the chart to zoom in',
            align: 'left'
        },
        xAxis: {
            type: 'datetime'
        },
        yAxis: {
            title: {
                text: props.series_name
            }
        },
        legend: {
            enabled: false
        },
        plotOptions: {
            area: {
                fillColor: {
                    linearGradient: {
                        x1: 0,
                        y1: 0,
                        x2: 0,
                        y2: 1
                    },
                    stops: [
                        [0, Highcharts.getOptions().colors[0]],
                        [1, Highcharts.color(Highcharts.getOptions().colors[0]).setOpacity(0).get('rgba')]
                    ]
                },
                marker: {
                    radius: 2
                },
                lineWidth: 1,
                states: {
                    hover: {
                        lineWidth: 1
                    }
                },
                threshold: null
            },
            
        },
        credits: {
            enabled: false,
        },
        series: [
            {
                name: props.series_name,
                type: 'area',
                data: data,
                dataLabels: {
                    enabled: true,
                    formatter: function(){
                        if (showDataLabels == false) return ''
                        if (metric == 1 && this.y == 0) return ''
                        if (metric == 1) return this.y
                        if (metric >= 2 && metric <= 4) return this.y.toFixed(1) 
                        if (metric == 5) return this.y.toFixed(1) + '%'
                        if (metric >= 6) return '$' + this.y.toFixed(0)
                    }
                },
                tooltip: {
                    valueDecimals: 0,
                },
            },
        ],
    };

    const onChangeshowDataLabels = (e) => {
        setShowDataLabels(e.target.checked);
    };

    return (
        <StyledWrapper open={open} onClose={onClose}>
            <StyledModal >
                <StyledHeader>
                    <StyledTitle>{title}</StyledTitle>
                    {showCloseIcon ? <StyledIcon onClick={onClose} /> : <div />}
                </StyledHeader>
                <Wrapper>
                    <SingleBlock width="20px"/>
                    <SingleBlock width="70px">
                        <Section title='Metric:'/>
                    </SingleBlock>
                    <SingleBlock width="15%">
                        <Dropdown
                            options={optionsMetrics}
                            onChange={onMetricChange}
                            value={metric}/>
                    </SingleBlock>
                    <SingleBlock width="130px">
                        <Section title='Show Data Labels:'/>
                    </SingleBlock>
                    <SingleBlock width="50px">
                        <Checkbox
                            label=''
                            checked={showDataLabels}
                            handleOnChange={onChangeshowDataLabels} />
                    </SingleBlock>
                </Wrapper>

                <StyledContent>
                    <Analytic>
                        <HighChart options={options} />
                    </Analytic> 
                </StyledContent>
                {
                    showButtons && (
                        <StyledFooter>
                            <Button label='Close' onClick={onClose} disabled={false} />
                        </StyledFooter>
                    )
                }
            </StyledModal>
        </StyledWrapper>
    );
};

